<mat-icon (click)="closeDialog()" [style]="'margin-bottom: 2vh;'">clear</mat-icon>
<h3 id="extra-spacing">Location Overrides</h3>

@if (loading) {
    <div class="loading-container">
        <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
        <p class="loading-text">Loading location overrides...</p>
    </div>
}

@if (notFound) {
    <div class="loading-container">
        <p>Location overrides not found for {{ attributeDisplayName }}</p>
    </div>
}

@if (!loading && !notFound) {
    <div>
        <div class="mat-elevation-z2 table-container">
            @if (formattedOverrides?.length > 0) {
                <table mat-table [dataSource]="formattedOverrides"
                       aria-describedby="unpublished changes">
                    <ng-container matColumnDef="key">
                        <th mat-header-cell *matHeaderCellDef class="text-wrapper text-center"><strong>Location</strong>
                        </th>
                        <td mat-cell *matCellDef="let row" class="text-wrappe text-center">{{ row.key }}</td>
                    </ng-container>
                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef class="text-wrapper text-center"><strong>Override
                            Value</strong></th>
                        <td mat-cell *matCellDef="let row" class="text-wrapper text-center">{{ row.value }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                        [ngClass]="{ 'current-value-row': (row.key === inheritedFrom)}"></tr>
                </table>
                @if(inheritedFrom) {
                    <p class="current-value-note">
                        Highlighted row indicates the current value matches this override.
                    </p>
                }
            }
        </div>
        @if (formattedOverrides?.length === 0 || !formattedOverrides) {
            <div style="text-align: center">
                There are no overrides for {{ attributeDisplayName }}
            </div>
        }
    </div>
}
